import React, { Component } from 'react';
import classes from './Intro.module.scss';

import Button from '../../components/Button/Button';
import {connect} from "react-redux";
import * as actionTypes from "../../store/actions";

class Intro extends Component {

    render() {

        return (
            <div className={classes.Intro}>
                <h2 className={classes.HeadingIntro}>Answer five quick questions and get your instant quote!</h2>

                <Button onButtonClick={this.props.startSurvey}
                        addClass={classes.IntroButton}
                >Let's Get Started!</Button>
            </div>
        );

    }

}

const mapStateToProps = state => {
    return {
        intro: state.intro,
        mode: state.mode
    }
};

const mapDispatchToProps = dispatch => {
    return {
        startSurvey: () => dispatch( { type: actionTypes.START_SURVEY } )
    }
};

export default connect( mapStateToProps, mapDispatchToProps )( Intro );